var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"area-graph-wrapper"}},[_c('div',{staticClass:"mx--4 mb--4"},[(_vm.series)?_c('div',[_c('apexchart',{attrs:{"type":"area","height":"115","width":"100%","options":_vm.chartOptions,"series":_vm.series}})],1):_c('div',{staticStyle:{"height":"30px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }